import { z } from 'zod'
import { QuizSchema } from '@/core/infrastructure/schemas/quiz/QuizSchema.ts'

export const ReferentialTaskSchema = z.object({
  id: z.number(),
  title: z.string(),
  order: z.number(),
  quizStart: QuizSchema.optional(),
  quizEnd: QuizSchema.optional()
})

export const ReferentialTaskListSchema = z.array(ReferentialTaskSchema)

export type ReferentialTaskEntity = z.infer<typeof ReferentialTaskSchema>
export type ReferentialTaskListEntity = z.infer<typeof ReferentialTaskListSchema>
